export const FLEET_PROCESSING_PERMISSIONS = {
    DELETE_PURCHASEORDERS : "Delete_PurchaseOrders",
    CREATE_UPDATE_PURCHASEORDERS : "Create_Update_PurchaseOrders",
    VIEW_PURCHASEORDERS: "View_PurchaseOrders",
    VIEW_FLEET_ADMIN_TASKS: "View_FleetAdminTasks",
    UPDATE_FLEET_ADMIN_TASKS: "Update_FleetAdminTasks",
    EDIT_FLEET_ADMIN_TASKS: "Edit_FleetAdminTasks",
    RETURN_TO_REQUESTOR : "ReturnToRequestor_FleetProcessing",
    EDIT_FLEET_ADMIN_INVOICE_TASKS : "Edit_FleetAdmin_InvoiceTasks"
}